import { render } from "./GoalsBox.vue?vue&type=template&id=4a3ac6a6&scoped=true"
import script from "./GoalsBox.vue?vue&type=script&lang=js"
export * from "./GoalsBox.vue?vue&type=script&lang=js"

import "./GoalsBox.vue?vue&type=style&index=0&id=4a3ac6a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a3ac6a6"]])

export default __exports__